import { AuthCalculationRule, AuthDomainContext } from '../auth.domain';

export class AuthenticationHydrationRule implements AuthCalculationRule {
	/**
	 * Calcula los valores de userName, userEmail e isLoggedIn
	 */
	public calculate(context: AuthDomainContext): AuthDomainContext {
		if (!context.authentication) return context;

		const { nombreCompleto, nombre, apellido, correo: email } = context.authentication;

		return {
			...context,
			userName: nombreCompleto ?? [nombre, apellido].join(' '),
			userEmail: email ?? null,
		};
	}
}
